import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  bindVehicleInfoGroups,
  unBindVehicleInfoGroups,
  bindVehicleInfos,
  unBindVehicleInfos,
  changeRecursion,
} from '@/api/analysisrangeserv'

export default {
  state: {
    state_AnalysisRange_GetAllResult: null,
    state_AnalysisRange_SearchByNameResult: null,
    state_AnalysisRange_GetPageResult: null,
    state_AnalysisRange_GetDetailResult: null,
    state_AnalysisRange_ModifyObjResult: null,
    state_AnalysisRange_BindVehicleInfoGroupsResult: null,
    state_AnalysisRange_UnBindVehicleInfoGroupsResult: null,
    state_AnalysisRange_BindVehicleInfosResult: null,
    state_AnalysisRange_UnBindVehicleInfosResult: null,
    state_AnalysisRange_ChangeRecursionResult: null,
  },
  mutations: {
    SET_ANALYSISRANGE_GETALL_RESULT: (state, rst) => {
      state.state_AnalysisRange_GetAllResult = rst;
    },
    SET_ANALYSISRANGE_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_AnalysisRange_SearchByNameResult = rst;
    },
    SET_ANALYSISRANGE_GETPAGE_RESULT: (state, rst) => {
      state.state_AnalysisRange_GetPageResult = rst;
    },
    SET_ANALYSISRANGE_GETDETAIL_RESULT: (state, rst) => {
      state.state_AnalysisRange_GetDetailResult = rst;
    },
    SET_ANALYSISRANGE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_AnalysisRange_ModifyObjResult = rst;
    },
    SET_ANALYSISRANGE_BINDVEHICLEINFOGROUPS_RESULT: (state, rst) => {
      state.state_AnalysisRange_BindVehicleInfoGroupsResult = rst;
    },
    SET_ANALYSISRANGE_UNBINDVEHICLEINFOGROUPS_RESULT: (state, rst) => {
      state.state_AnalysisRange_UnBindVehicleInfoGroupsResult = rst;
    },
    SET_ANALYSISRANGE_BINDVEHICLEINFOS_RESULT: (state, rst) => {
      state.state_AnalysisRange_BindVehicleInfosResult = rst;
    },
    SET_ANALYSISRANGE_UNBINDVEHICLEINFOS_RESULT: (state, rst) => {
      state.state_AnalysisRange_UnBindVehicleInfosResult = rst;
    },
    SET_ANALYSISRANGE_CHANGERECURSION_RESULT: (state, rst) => {
      state.state_AnalysisRange_ChangeRecursionResult = rst;
    },
  },
  actions: {
    AnalysisRangeServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_BindVehicleInfoGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindVehicleInfoGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_BINDVEHICLEINFOGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_BINDVEHICLEINFOGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_UnBindVehicleInfoGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        unBindVehicleInfoGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_UNBINDVEHICLEINFOGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_UNBINDVEHICLEINFOGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_BindVehicleInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindVehicleInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_BINDVEHICLEINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_BINDVEHICLEINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_UnBindVehicleInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        unBindVehicleInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_UNBINDVEHICLEINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_UNBINDVEHICLEINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AnalysisRangeServ_ChangeRecursion({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeRecursion(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ANALYSISRANGE_CHANGERECURSION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ANALYSISRANGE_CHANGERECURSION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_AnalysisRange_GetAllResult: state => {
      return state.state_AnalysisRange_GetAllResult;
    },
    get_AnalysisRange_SearchByNameResult: state => {
      return state.state_AnalysisRange_SearchByNameResult;
    },
    get_AnalysisRange_GetPageResult: state => {
      return state.state_AnalysisRange_GetPageResult;
    },
    get_AnalysisRange_GetDetailResult: state => {
      return state.state_AnalysisRange_GetDetailResult;
    },
    get_AnalysisRange_ModifyObjResult: state => {
      return state.state_AnalysisRange_ModifyObjResult;
    },
    get_AnalysisRange_BindVehicleInfoGroupsResult: state => {
      return state.state_AnalysisRange_BindVehicleInfoGroupsResult;
    },
    get_AnalysisRange_UnBindVehicleInfoGroupsResult: state => {
      return state.state_AnalysisRange_UnBindVehicleInfoGroupsResult;
    },
    get_AnalysisRange_BindVehicleInfosResult: state => {
      return state.state_AnalysisRange_BindVehicleInfosResult;
    },
    get_AnalysisRange_UnBindVehicleInfosResult: state => {
      return state.state_AnalysisRange_UnBindVehicleInfosResult;
    },
    get_AnalysisRange_ChangeRecursionResult: state => {
      return state.state_AnalysisRange_ChangeRecursionResult;
    },
  }
}